const hasBenchmark = data => {
  return data.benchmark && data.benchmark.length > 0;
};

const orderClasses = (obj, prop) => {
  return obj.sort((a, b) => (a[prop] > b[prop] ? 1 : -1));
};

const findMinMax = data => {
  let max = 0;
  let min = 0;
  data.forEach(item => {
    min = item.value < min ? item.value : min;
    max = item.value > max ? item.value : max;
  });
  return {
    min,
    max,
  };
};
// Return the max and min value of a portfolio (contains both portfolio and benchmark data)
// The actual logic of getting the edges had been moved to corresponding component
// This method can be further refactored
const getEdgeValues = chartData => {
  // Sorting arrays to get [0] as max value and [last element] as min value
  const portfolio = findMinMax(chartData.portfolio);
  const benchmark = hasBenchmark(chartData) ? findMinMax(chartData.benchmark) : { min: 0, max: 0 };

  // Find min and max on portfolio and benchmark values
  const allValues = [0, ...Object.values(portfolio), ...Object.values(benchmark)];
  const max = Math.max(...allValues);
  const min = Math.min(...allValues);
  return { min, max };
};

export { hasBenchmark, getEdgeValues, orderClasses };
